module.exports = __webpack_public_path__ + "img/player.e8561415.gif";